import { Instance } from 'mobx-state-tree';
import { VisitSchedulingFailedDtoModelBase } from './VisitSchedulingFailedDtoModel.base';

/* The TypeScript type of an instance of VisitSchedulingFailedDtoModel */
export interface VisitSchedulingFailedDtoModelType extends Instance<typeof VisitSchedulingFailedDtoModel.Type> {}

/* A graphql query fragment builders for VisitSchedulingFailedDtoModel */
export { selectFromVisitSchedulingFailedDto, visitSchedulingFailedDtoModelPrimitives, VisitSchedulingFailedDtoModelSelector } from './VisitSchedulingFailedDtoModel.base';
/**
 * VisitSchedulingFailedDtoModel
 */
export const VisitSchedulingFailedDtoModel = VisitSchedulingFailedDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
